import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { PopupComponent } from "sharedFeatures/window";
import { SharedGuiSmallModule } from '../../../../sharedGuiSmall/sharedGuiSmall.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'save-close-pane',
    templateUrl: './save-close-pane.component.html',
    styleUrls: ['./save-close-pane.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, TranslateModule]
})

export class SaveClosePane extends PopupComponent {

    public saveClosePresent: boolean = false;

    public saveCloseHandler: Function = function(){};
    public saveHandler: Function = function(){};
    public cancelHandler: Function = function(){};
    public isValid: boolean = true;

    topest = true;

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {

        super(element, r, viewContainerRef, chDet);

        this.backgroundFill = 'white-background';

        this.cornerRadius = 0;

        this.shadowStyle = 'save-close-shadow';

        this.useFadeIn = false;

        this.useSlide = true;
    }

    public setSaveCloseHandler(fn: Function): void {

        this.saveCloseHandler = fn;

    }

    public setSaveHandler(fn: Function): void {

        this.saveHandler = fn;

    }

    public setCancelHandler(fn: Function): void {

        this.cancelHandler = fn;

    }

    public isSaveClosePresent(): boolean {

        return this.saveClosePresent;

    }

    public setSaveClosePresent(present: boolean): void {

        this.saveClosePresent = present;

    }

    public async show(x: number, y: number, focusAfterShow?: boolean) {

        this.chDet.detectChanges();
        await super.show(x, y, focusAfterShow);

    }

}
